import api from "api";
import { supportApiBase } from "api/constants";
import { useMutation, useQueryClient } from "react-query";
import { queryKeys } from "utils/misc";

export const useDeleteLesson = () => {
  const queryClient = useQueryClient();
  return useMutation(
    (id: number) =>
      // @ts-ignore
      api(`DELETE /lessons/${id}`, { root: supportApiBase }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(queryKeys.lessons);
      },
    }
  );
};
